import React from "react"
import PropTypes from "prop-types"
import { FieldArray } from "react-final-form-arrays"
import PlantTypeForm from "./PlantTypeForm"

export default class PriceCalculationProducerForm extends React.Component {
  render() {
    return (
      <FieldArray name="supported_plant_types">
        {({ fields }) => (
          <PlantTypeForm fields={fields} disabled={this.props.disabled} />
        )}
      </FieldArray>
    )
  }
}

PriceCalculationProducerForm.propTypes = {
  disabled: PropTypes.bool
};
